export default {
  currencies: {
    DOP: 'República Dominicana',
    USD: 'Estados Unidos',
    COP: 'Colombia',
    MXN: 'México',
    ARS: 'Argentina',
    CLP: 'Chile',
    PEN: 'Perú',
    BSD: 'Bahamas',
    ANG: 'Curazao',
  },
  countries: {
    AR: 'Argentina',
    BS: 'Bahamas',
    CL: 'Chile',
    CO: 'Colombia',
    CW: 'Curazao',
    DO: 'República Dominicana',
    MX: 'México',
    PE: 'Perú',
  },
  countrySelect: {
    placeholder: 'Elija un país',
  },
  app: {
    title: 'StreetLoans',
    logout: 'Cerrar sesión',
    language: 'Idioma',
    toggleTheme: 'Cambiar tema',
    theme: {
      toDark: 'Cambiar a tema oscuro',
      toLight: 'Cambiar a tema claro',
    },
    toggleMenu: 'Menú',
    mainNavigation: 'Navegación principal',
    collapseMenu: 'Contraer menú',
    userMenu: 'Cuenta',
  },
  menu: {
    commissions: 'Comisiones',
    groups: {
      home: 'Inicio',
      applications: 'Solicitudes',
      loans: 'Préstamos',
      finance: 'Finanzas',
      more: 'Más',
    },
    dashboard: 'Panel',
    customers: 'Clientes',
    loans: 'Préstamos',
    collections: 'Por cobrar',
    myPayments: 'Mis cobros',
    loanRequests: 'Solicitudes',
    myLoanRequests: 'Mis solicitudes',
    loanTables: 'Tablas',
    accounting: 'Finanzas',
    routes: 'Rutas',
    members: 'Equipo',
    roles: 'Roles',
    import: 'Importar cartera',
    paymentReview: 'Revisión',
    loanCalculator: 'Calculadora',
    settings: 'Configuración',
    cashClose: 'Cierre de caja',
    finance: {
      overview: 'Posición y resultado',
      chart: 'Catálogo de cuentas',
      transactions: 'Movimientos',
      expenses: 'Gastos',
      impairment: 'Deterioro',
      periodClose: 'Cierre de período',
      postingRules: 'Reglas de asiento',
    },
  },
  platform: {
    badge: 'Plataforma',
    menu: {
      overview: 'Resumen',
      plans: 'Planes',
      tenants: 'Clientes',
      accounts: 'Cuentas',
    },
    accounts: {
      title: 'Auditoría de cuentas',
      subtitle: 'Todas las cuentas web, incluso registros ocultos e inconsistentes.',
      email: 'Correo',
      state: 'Estado',
      memberships: 'Membresías',
      active: 'Activa',
      inactive: 'Inactiva',
      allStatuses: 'Todos los estados',
      allTypes: 'Todos los tipos',
      orphan: 'Huérfana',
      shared: 'Compartida',
      inconsistent: 'Inconsistente',
      platformAdmin: 'Administrador de plataforma',
      member: 'Miembro',
      noRoles: 'Sin roles',
      missingRole: 'Rol faltante',
      empty: 'No hay cuentas que coincidan con estos filtros.',
      cleanup: 'Eliminar huérfana',
      cleanupConfirm: '¿Eliminar la cuenta huérfana {email}? No se puede deshacer.',
      cleanupSucceeded: 'Se eliminó la cuenta huérfana.',
      cleanupFailed: 'No se pudo eliminar la cuenta huérfana.',
    },
    tenants: {
      title: 'Clientes',
      subtitle: 'Los negocios que prestan con StreetLoans.',
      create: 'Nuevo cliente',
      createTitle: 'Nuevo cliente',
      createFailed: 'No se pudo crear el cliente.',
      created: 'Creado. La contraseña temporal va en camino a {email}.',
      edit: 'Editar',
      editTitle: 'Editar negocio',
      updated: 'Se guardó el negocio.',
      updateFailed: 'No se pudo guardar el negocio.',
      emailFailed:
        'El negocio se creó, pero falló el correo con la contraseña temporal. Provisione una nueva antes de avisarles.',
      emptyList: 'Todavía no hay clientes.',
      emptyHint: 'Al crear uno se arma el negocio y se le envía al dueño una contraseña temporal por correo.',
      name: 'Negocio',
      owner: 'Dueño',
      ownerEmail: 'Correo del dueño',
      ownerEmailHint:
        'Recibe una contraseña temporal por correo y elige la suya al entrar por primera vez.',
      passwordPending: 'Contraseña temporal enviada a {email}',
      ceiling: 'Tope',
      ceilingFromPlan: 'El del plan',
      editCeiling: 'Tope de préstamos',
      ceilingHint:
        'Préstamos vivos que puede llevar este negocio, por encima de lo que da su plan. Quítelo para que vuelva a regir el del plan.',
      clearCeiling: 'Quitar el tope propio',
      ceilingFailed: 'No se pudo cambiar el tope.',
      suspend: 'Suspender',
      reactivate: 'Reactivar',
      suspendTitle: 'Suspender negocio',
      suspendWarning:
        'Nadie de {name} va a poder entrar — ni el dueño ni sus cobradores — hasta que lo reactive. No se borra nada: la cartera, los libros y el equipo siguen ahí.',
      suspendReason: 'Motivo',
      suspendReasonHint: 'Queda en el registro para quien lo lea después. Opcional, pero ayuda.',
      activeFailed: 'No se pudo cambiar el estado del negocio.',
      noOwner: 'Sin dueño todavía',
      plan: 'Plan',
      country: 'País',
      countryHint: 'Define las tablas gota a gota con las que arranca el negocio.',
      status: 'Estado',
      createdAt: 'Creado',
      inactive: 'Inactivo',
      noSubscription: 'Sin suscripción',
      noSellablePlans: 'No hay ningún plan a la venta, así que no se puede crear a nadie. Ponga uno en la lista primero.',
      editOwner: 'Editar correo del dueño',
      ownerUpdated: 'Se guardó el correo del dueño.',
      ownerFailed: 'No se pudo guardar el correo del dueño.',
      changePlan: 'Cambiar plan',
      planUpdated: 'Se cambió el plan de suscripción.',
      planFailed: 'No se pudo cambiar el plan de suscripción.',
      planWarning: 'Cambiar a {name} a otro plan puede modificar lo que el negocio puede usar.',
      extendSubscription: 'Extender suscripción',
      extensionDays: 'Días para extender',
      extensionUpdated: 'Se extendió la suscripción.',
      extensionFailed: 'No se pudo extender la suscripción.',
      resendAccess: 'Reenviar acceso del dueño',
      resendWarning: 'Envíe una nueva contraseña temporal al dueño de {name}. La contraseña temporal anterior dejará de funcionar.',
      resendDelivered: 'Se envió una nueva contraseña temporal al dueño.',
      audit: 'Auditoría',
      users: 'Usuarios',
      memberships: 'Membresías',
      emptyTenant: 'Tenant vacío',
      customers: 'Clientes',
      loans: 'Préstamos',
      delete: 'Eliminar tenant',
      deleteTitle: 'Eliminar tenant',
      deleteWarning: '¿Eliminar {name} permanentemente?',
      deleteConfirmationWarning: 'Esta acción borra permanentemente todos los datos del negocio y no se puede deshacer. Escriba eliminar para confirmar.',
      deleteConfirmationLabel: 'Escriba eliminar para confirmar',
      deleted: 'Se eliminó el tenant.',
      deleteFailed: 'No se pudo eliminar el tenant.',
      resendFailed: 'Se actualizó el acceso, pero no se entregó el correo con la contraseña temporal.',
      statuses: {
        Trialing: 'Prueba',
        Active: 'Activo',
        PastDue: 'En mora',
        Canceled: 'Cancelado',
      },
    },
    plans: {
      title: 'Planes',
      subtitle: 'Lo que vende la plataforma y lo que habilita cada plan.',
      create: 'Nuevo plan',
      createTitle: 'Nuevo plan',
      editTitle: 'Editar plan',
      edit: 'Editar',
      emptyList: 'La estantería está vacía.',
      emptyHint: 'Un plan es lo que se le vende a un negocio. Cree uno antes de agregar clientes.',
      basicInfo: 'Plan',
      name: 'Nombre',
      code: 'Código',
      codeHint: 'Minúsculas, dígitos y guiones. No se puede cambiar después.',
      codeLocked: 'El código es lo que apunta cada suscripción, por eso no cambia nunca. Cambie el nombre del plan.',
      monthlyPrice: 'Precio mensual',
      loanLimit: 'Tope de préstamos',
      loanLimitHint: 'Préstamos vivos que puede llevar un negocio en este plan. Déjelo vacío para ilimitado. En el tope solo se bloquea desembolsar: los pagos y las solicitudes siguen funcionando.',
      unlimited: 'Ilimitado',
      capabilitiesLabel: 'Capacidades',
      noCapabilities: 'Ninguna',
      tenants: 'Negocios',
      retired: 'Retirado',
      availableHint: 'A la venta. Un plan retirado sigue sirviendo a los negocios que ya lo tienen.',
      saved: 'Plan guardado.',
      saveFailed: 'No se pudo guardar el plan.',
      revokeWarning:
        'Negocios en este plan: {count}. Al guardar se les quita: {capabilities}.',
      retireWarning:
        'Negocios en este plan: {count}. Lo conservan: retirarlo solo lo saca de la venta.',
      capabilities: {
        collectors: 'Cobradores',
        routes: 'Rutas de cobro',
        accounting: 'Finanzas',
      },
    },
    overview: {
      title: 'Administración de la plataforma',
      carries:
        'Todavía no hay negocios en la plataforma. | {count} negocio en la plataforma. | {count} negocios en la plataforma.',
      onTrial: 'ninguno en prueba | {count} en prueba | {count} en prueba',
      needsYou: 'Requiere su atención',
      stats: {
        revenue: 'Ingreso mensual',
        revenueNote: 'De {count} negocios pagando.',
        businesses: 'Negocios',
        newThisMonth: '{count} nuevos este mes.',
        trialing: 'En prueba',
        endingSoon: '{count} terminan esta semana — llámelos.',
        noneEndingSoon: 'Ninguna termina esta semana.',
        attention: 'Requieren atención',
        attentionNote: 'Sin dueño adentro o suspendidos.',
      },
      allClear: 'Nada pendiente — todos los negocios tienen a su dueño adentro.',
      awaitingOwner: 'se envió la contraseña temporal a {email} y todavía no la reclama',
      suspended: 'suspendido',
      trialEnds: 'la prueba termina en {days} días',
      shelf: 'En la estantería',
      allPlans: 'Ver todos los planes',
      noPlans: 'La estantería está vacía, así que no se le puede vender un plan a nadie.',
      boundary:
        'Solo planes, precios y negocios. No puede abrir los clientes, préstamos ni pagos de un prestamista, ni iniciar sesión como uno de sus usuarios.',
    },
  },
  team: {
    isPromoter: 'Trae negocio (promotor)',
    promoterRate: 'Su comisión',
    promoterRateHint: 'Puntos de la tasa del préstamo. Vacío usa la comisión del negocio.',
    title: 'Personal',
    hint: 'Quién trabaja acá y qué puede hacer cada uno. Un empleado puede tener más de un rol.',
    hire: 'Registrar empleado',
    person: 'Persona',
    firstName: 'Nombre',
    lastName: 'Apellido',
    idNumber: 'Cédula',
    idNumberPlaceholder: '000-0000000-0',
    phone: 'Teléfono',
    email: 'Correo',
    address: 'Dirección',
    hiredOn: 'Fecha de ingreso',
    roles: 'Roles',
    rolesPlaceholder: 'Elija uno o más',
    roleRequired: 'Elija al menos un rol. Un empleado sin rol entra al sistema y no puede hacer nada.',
    status: 'Estado',
    active: 'Activo',
    revoked: 'Dado de baja',
    change: 'Cambiar',
    stillWorksHere: 'Sigue trabajando acá',
    handover: 'Cuenta creada para {email}. Entréguele esta contraseña ahora:',
    handoverHint: 'No se envía por correo. Se muestra una sola vez y el empleado la cambia al entrar.',
    updated: 'Empleado actualizado.',
    updateFailed: 'No se pudo actualizar al empleado.',
    hireFailed: 'No se pudo registrar al empleado.',
    remove: 'Eliminar',
    emailEditHint: 'Corrija aquí un correo mal escrito. La persona entrará con el nuevo.',
    loadFailed: 'No se pudo cargar el personal.',
  },
  api: {
    team: {
      employeeHired: 'Empleado registrado. Entréguele la contraseña temporal.',
      profileUpdated: 'Se actualizó su perfil.',
      photoUpdated: 'Se actualizó su foto.',
      photoRemoved: 'Se quitó su foto.',
      roleRequired: 'Elija al menos un rol. Un empleado sin rol no puede hacer nada.',
      roleNotYours: 'Ese rol no pertenece a este negocio.',
      emailTaken: 'Ya hay una cuenta con ese correo.',
      idNumberTaken: 'Ya hay un empleado con esa cédula.',
      detailsIncomplete: 'Faltan datos del empleado: nombre, apellido, cédula y teléfono son obligatorios.',
      employeeUpdated: 'Empleado actualizado.',
      unknownPermission: '“{permission}” no es un permiso.',
      employeeNotFound: 'Ese empleado no pertenece a este negocio.',
      cannotRevokeYourself: 'No puede darse de baja a usted mismo.',
      employeeRemoved: 'Se eliminó el empleado.',
      employeeHasSignedIn: 'Ya entró al sistema, así que tiene historial. Desactívelo en vez de eliminarlo.',
      wouldLeaveNoAdmin: 'El negocio quedaría sin nadie que pueda administrar usuarios.',
    },
    migration: {
      backupRejected: 'El respaldo trae un dato corrupto: {reason}',
      nothingToImport: 'El respaldo no trae clientes ni préstamos para importar.',
      bookNotEmpty: 'Este negocio ya tiene datos. Solo se importa sobre un libro vacío.',
      paymentWithoutInstallment: 'Un pago apunta a una cuota que no viene en el respaldo.',
      loanWithoutCustomer: 'El préstamo «{code}» apunta a un cliente que no viene en el respaldo.',
      installmentWithoutLoan: 'La cuota #{number} apunta a un préstamo que no viene en el respaldo.',
    },
    platform: {
      tenantNameRequired: 'El negocio necesita un nombre.',
      ownerEmailInvalid: 'El correo del dueño no es válido.',
      noStartingTables: 'No hay tablas iniciales para «{country}». Disponibles: {known}.',
      planCodeUnknown: 'No hay ningún plan con el código «{code}».',
      planRetired: 'El plan «{name}» está retirado y no se vende.',
      emailHasAccount: '{email} ya tiene una cuenta.',
      tenantCreatedFor: 'Se creó «{name}». La contraseña temporal va camino a {email}.',
      tenantCreatedEmailFailedFor: 'Se creó «{name}», pero falló el correo con la contraseña temporal. Provisione una nueva antes de avisarles.',
      ceilingSet: 'Este negocio puede llevar {ceiling} préstamos vivos.',
      ceilingCleared: 'Vuelve a regir el tope del plan.',
      tenantAlreadyActive: 'Ese negocio ya está activo.',
      tenantAlreadySuspended: 'Ese negocio ya está suspendido.',
      planCodeRequired: 'El plan necesita un código.',
      planNameRequired: 'El plan necesita un nombre.',
      planPriceNotNegative: 'Un plan no puede costar menos que nada.',
      planLimitZero: 'Un tope de cero vendería un plan que nunca puede prestar; déjelo vacío para ilimitado.',
      planGone: 'Ese plan ya no existe.',
      ceilingAtLeastOne: 'El tope tiene que ser de al menos un préstamo. Quítelo para que rija el del plan.',
      noSubscriptionForCeiling: 'Ese negocio no tiene suscripción a la que ponerle tope.',
      tenantGone: 'Ese negocio no existe.',
      cannotSuspendPlatform: 'El negocio propio de la plataforma no se puede suspender.',
      planCodeShape: '«{code}» no sirve como código de plan: use hasta {max} letras minúsculas, números y guiones.',
      unknownCapability: '«{capability}» no es una capacidad.',
      planCodeTaken: 'Ya existe un plan con el código «{code}».',
      planCreated: 'Se creó el plan «{name}».',
      planSaved: 'Se guardó el plan «{name}».',
      tenantActiveAgain: '«{name}» está activo de nuevo.',
      tenantSuspended: '«{name}» está suspendido. Nadie de ese negocio puede entrar.',
      countryNotSupported: 'Ese país no está soportado.',
      notAPlatformAdmin: 'Sólo un administrador de la plataforma puede hacer esto.',
      tenantUpdated: 'Se guardó el negocio.',
      tenantPlanChanged: 'Se cambió el plan de suscripción.',
      tenantPeriodExtended: 'Se extendió el período de suscripción.',
      extensionDaysRequired: 'Indique cuántos días desea extender la suscripción.',
      subscriptionCannotExtend: 'No se puede extender esta suscripción.',
      ownerAmbiguous: 'Se encontraron varios dueños para este negocio.',
      ownerEmailUpdated: 'Se actualizó el correo del dueño.',
      ownerAccessResent: 'Se envió un nuevo acceso temporal al dueño.',
      ownerAccessResendEmailFailed: 'El acceso se actualizó, pero no se pudo entregar el correo con la contraseña temporal.',
      tenantDeleted: 'Se eliminó el negocio.',
      tenantHasFinancialData: 'No se puede eliminar este negocio porque tiene datos financieros.',
      tenantDeleteConfirmationRequired: 'Escriba eliminar para confirmar la eliminación del negocio y sus datos de clientes y préstamos.',
      cannotDeletePlatform: 'No se puede eliminar el negocio de la plataforma.',
      accountGone: 'Esa cuenta ya no existe.',
      accountHasMemberships: 'Esta cuenta todavía tiene membresías y no se puede eliminar.',
      orphanAccountDeleted: 'Se eliminó la cuenta huérfana.',
    },
    auth: {
      recoveryHashNotUpdated: 'No se pudo actualizar el código de recuperación: {reason}',
      temporaryPasswordExpired: 'Esta contraseña temporal venció. Pida una nueva desde la consola.',
      mustChangePassword: 'Tiene que cambiar su contraseña temporal antes de hacer cualquier otra cosa.',
      currentPasswordWrong: 'La contraseña actual no es correcta.',
      passwordTooWeak: 'La contraseña nueva no cumple los requisitos de seguridad.',
      accountNotCreated: 'No se pudo crear la cuenta: {reason}',
      ownerRegistered: 'Listo. Ponga el código que le acabamos de enviar.',
      ownerRegisteredOtpFailed: 'Se registró, pero no se pudo enviar el código; pídalo de nuevo.',
      newPasswordRequired: 'Falta la contraseña nueva.',
      newPasswordMustDiffer: 'La contraseña nueva tiene que ser distinta de la actual.',
      accountNotFound: 'No se encontró la cuenta.',
      passwordUpdated: 'Contraseña actualizada. Vuelva a entrar en sus otros dispositivos.',
      fingerprintRequired: 'Falta la huella del dispositivo.',
      invalidCredentials: 'Correo o contraseña incorrectos.',
      temporarilyLocked: 'Demasiados intentos fallidos. La cuenta se desbloquea sola en {minutes} minutos — su contraseña sigue siendo válida, no hace falta cambiarla.',
      emailNotVerified: 'El correo no está verificado. Ponga el código que le enviamos para activar la cuenta.',
      accessNoLongerActive: 'Su acceso a este negocio ya no está activo.',
      loginSuccess: 'Entró correctamente.',
      ok: 'Listo',
      noActiveMembership: 'No tiene membresía activa en este negocio.',
      refreshTokenInvalid: 'La sesión ya no es válida; vuelva a entrar.',
      sessionSignedInElsewhere: 'Se inició sesión con esta cuenta en otro navegador. Solo puede haber una sesión web abierta a la vez.',
      sessionSignedOut: 'La sesión se cerró. Vuelva a entrar.',
      sessionExpired: 'La sesión venció por inactividad. Vuelva a entrar.',
      sessionPasswordChanged: 'Se cambió la contraseña de esta cuenta, así que las sesiones abiertas se cerraron.',
      sessionRevokedByAdmin: 'Un administrador cerró esta sesión.',
      ownerNotFound: 'No se encontró al dueño.',
      tokenRefreshed: 'Sesión renovada.',
      emailAlreadyRegistered: 'Ese correo ya está registrado.',
      recoveryHashRequired: 'Falta el código de recuperación.',
      recoveryHashUpdated: 'Se actualizó el código de recuperación.',
      passwordResetRequested: 'Si la cuenta existe, le enviamos un enlace.',
      passwordResetInvalid: 'El enlace no es válido o ya venció. Pida uno nuevo.',
      passwordReset: 'Su contraseña quedó cambiada.',
      otpChallengeInvalid: 'El código de verificación no es válido o venció.',
      otpCodeInvalid: 'El código de verificación no es correcto.',
      contactVerified: 'Contacto verificado.',
    },
    memberships: {
      accountNotCreated: 'No se pudo crear la cuenta: {reason}',
      ok: 'Listo',
      namesRequired: 'Hacen falta el nombre y el apellido.',
      roleNotFound: 'No se encontró el rol.',
      memberNotFound: 'No se encontró a esa persona.',
      cannotRemoveLastAdmin: 'No se le puede quitar la gestión de usuarios al último administrador activo.',
      emailRequired: 'Hace falta un correo válido.',
      passwordRequired: 'Falta la contraseña.',
      emailTaken: 'Ese correo ya está registrado.',
      employeeCreated: 'Se creó el empleado.',
      cannotDeactivateLastAdmin: 'No se puede desactivar al último administrador activo.',
      memberDeactivated: 'Persona desactivada. Su acceso termina con esta solicitud.',
      permissionCoveredByRole: 'Ese permiso ya viene con el rol de esa persona.',
      permissionAlreadyGranted: 'Ese permiso ya estaba dado.',
      memberReactivated: 'Persona reactivada.',
      noGrantToRevoke: 'No hay ningún permiso extra que quitar.',
      roleAssigned: 'Se asignó el rol «{role}».',
      unknownPermission: '«{permission}» no es un permiso.',
      permissionGranted: 'Se dio «{permission}».',
      permissionRevoked: 'Se quitó «{permission}».',
    },
    roles: {
      nameRequired: 'Falta el nombre del rol.',
      notFound: 'No se encontró el rol.',
      systemCannotDelete: 'Un rol del sistema no se borra.',
      inUse: 'Ese rol está asignado a alguien del equipo. Reasígnelos primero.',
      adminLocked: 'El rol Administrador está bloqueado y no se edita.',
      wouldLeaveNoAdmin: 'No se puede quitar la gestión de usuarios de este rol: el negocio quedaría sin administrador.',
      unknownPermission: '«{permission}» no es un permiso.',
      nameTaken: 'Ya existe un rol llamado «{name}».',
      created: 'Se creó el rol «{name}».',
      deleted: 'Se borró el rol «{name}».',
      updated: 'Se actualizó el rol «{name}».',
    },
    payments: {
      waivePermissionNeeded: 'Para descontar hace falta el permiso de descuentos; registre el monto completo o pida que se lo den.',
      subscriptionInactive: 'Su suscripción está inactiva; solo se registran los pagos cobrados antes de que venciera.',
      installmentAlreadyPaid: 'Esa cuota ya está pagada.',
      exceedsBalance: 'El pago pasa el saldo pendiente más la mora.',
      loanCancelled: 'El préstamo {code} está cancelado; no se le cobra nada.',
      fundingSourceNotOurs: 'Esa fuente no es una en la que este negocio pueda cobrar.',
      noFundingSource: 'Este negocio no tiene ninguna fuente donde cobrar.',
      sayWhichFundingSource: 'Diga a qué fuente entró este dinero.',
      reviewRejected: 'Rechazado: {reason}',
      noActiveMembership: 'Su cuenta no tiene acceso activo a este negocio.',
      receiptCodeShape: 'El código del recibo son ocho letras y números.',
      receiptDateRequired: 'Falta la fecha del recibo.',
      amountNotNegative: 'El monto del pago no puede ser negativo.',
      discountsNotNegative: 'Los descuentos no pueden ser negativos.',
      needsCashOrDiscount: 'Un pago lleva efectivo, un descuento, o los dos.',
      clientPaymentIdRequired: 'Falta el identificador del pago en el dispositivo.',
      installmentNotFound: 'No se encontró la cuota.',
      reviewItemNotFound: 'No se encontró el pago a revisar.',
      reviewAlreadyDecided: 'Ese pago ya fue revisado.',
      rejectionReasonRequired: 'Falta el motivo del rechazo.',
      approvedAmountRequired: 'Hace falta un monto aprobado mayor que cero.',
      approvedAmountTooHigh: 'El monto aprobado pasa el saldo actual más la mora pendiente.',
    },
    promoters: {
      houseRateNotAPercentage: 'La comisión del negocio tiene que ser un porcentaje mayor que cero.',
    },
    loans: {
      zoneRequired: 'Este cliente necesita una zona: elija la que lo cobra.',
      emptySchedule: 'Con esos parámetros el plan de pagos queda vacío.',
      notPriced: 'No se pudo calcular el préstamo: {reason}',
      notFound: 'No se encontró el préstamo.',
      alreadyPaidOff: 'Ese préstamo ya está saldado.',
      alreadyCancelled: 'Ese préstamo ya está cancelado.',
      tableAmountNotFound: 'No se encontró ese monto en la tabla.',
      principalPositive: 'El capital tiene que ser positivo.',
      fundingSourceRequired: 'Para desembolsar hace falta decir de qué fuente sale.',
      promoterNotFound: 'Esa persona no está registrada como promotor.',
      promoterInactive: 'Ese promotor ya no está activo.',
      promoterShareNotConfigured: 'No hay comisión configurada para ese promotor ni para el negocio.',
      promoterShareNotPositive: 'La comisión del promotor tiene que ser mayor que cero.',
      promoterShareExceedsLoanRate: 'La comisión del promotor no puede superar la tasa del préstamo.',
      fundingSourceNotFound: 'No se encontró la fuente.',
      installmentsPositive: 'La cantidad de cuotas tiene que ser positiva.',
      loanTypeRequired: 'Falta el tipo de préstamo.',
      customerNotFound: 'No se encontró al cliente.',
      codeNotAllocated: 'No se pudo asignar un código único. Intente de nuevo.',
      ratesNotNegative: 'Las tasas no pueden ser negativas.',
      onlyOpenLoanChanges: 'Solo se le cambian las condiciones a un préstamo abierto.',
      fundingSourceRetired: '«{name}» está retirada y no puede financiar un préstamo.',
      fundingSourceNotOpened: '«{name}» todavía no tiene saldo de apertura. Cárguelo en Configuración → Fuentes de fondeo y después preste desde ahí.',
      ceilingReached: 'Este plan permite {ceiling} préstamos activos y hay {open} abiertos.',
    },
    treasury: {
      boxNotOurs: 'Esa caja no es de este negocio.',
      alreadyClosed: 'Esa caja ya fue cerrada ese día. Una corrección es un cierre aparte.',
      depositBeyondCount: 'No puede depositar más de lo que contó.',
      depositNeedsDestination: 'Diga a qué cuenta entró el depósito.',
    },
    fundingSources: {
      nameRequired: 'La fuente necesita un nombre.',
      sourceGone: 'Esa fuente ya no existe.',
      openingNotNegative: 'Un saldo inicial no puede ser negativo.',
      transferPositive: 'Un traspaso es un monto positivo.',
      transferTwoSources: 'Un traspaso mueve dinero entre dos fuentes distintas.',
      pickTwoOpenSources: 'Elija dos de sus fuentes abiertas.',
      unknownKind: '«{kind}» no es un tipo de fuente.',
      nameTaken: 'Ya hay una fuente llamada «{name}».',
      saved: 'Se guardó «{name}».',
      openingAlreadySet: '«{name}» ya tiene su saldo inicial. Una corrección es un asiento aparte.',
      openingSet: '«{name}» abre con {amount}.',
      transferred: 'Se movieron {amount} de «{from}» a «{to}».',
      contributionPositive: 'Un aporte es un monto positivo.',
      sourceRetired: '«{name}» está retirada y no recibe dinero nuevo.',
      contributionAdded: 'Se agregaron {amount} a «{name}».',
    },
    entitlements: {
      trialNotActivated: 'No se pudo activar la prueba: {reason}',
      aliasNotRegistered: 'No se pudo registrar el dispositivo con la tienda: {reason}',
      subscriptionNotFound: 'No se encontró la suscripción.',
      trialActivated: 'Prueba activada.',
      anonymousIdRequired: 'Falta el identificador anónimo de la aplicación.',
      deviceLinked: 'El dispositivo quedó vinculado a la cuenta.',
      appUserIdEmpty: 'El identificador de la aplicación viene vacío.',
      ownerDoesNotExist: 'Esa cuenta no existe.',
    },
    recovery: {
      codeSentIfExists: 'Si hay una cuenta con ese correo, le acabamos de enviar un código.',
      completed: 'Recuperación completada.',
      completedDeviceReactivated: 'Recuperación completada. Se reactivó el dispositivo.',
      passwordNotReset: 'No se pudo cambiar la contraseña: {reason}',
      challengeInvalid: 'El desafío de recuperación no es válido.',
      codeInvalid: 'El código de recuperación no es válido.',
      ownerNotFound: 'No se encontró al dueño.',
      codeNotConfigured: 'Esta cuenta no tiene código de recuperación configurado.',
      emailAndCodeRequired: 'Hacen falta el correo y el código de recuperación.',
      accountNotFound: 'No se encontró la cuenta.',
    },
    loanRequests: {
      notCreated: 'No se pudo crear el préstamo: {reason}',
      notFound: 'No se encontró la solicitud.',
      alreadyDecided: 'Esa solicitud ya fue decidida.',
      principalPositive: 'El capital tiene que ser positivo.',
      installmentsPositive: 'La cantidad de cuotas tiene que ser positiva.',
      loanTypeRequired: 'Falta el tipo de préstamo.',
      customerNotFound: 'No se encontró al cliente.',
    },
    routes: {
      duplicateCustomer: 'La lista trae al mismo cliente más de una vez.',
      notFound: 'No se encontró la ruta.',
      customersNotFound: 'No se encontraron uno o más clientes.',
      nameRequired: 'Falta el nombre de la ruta.',
      nameTaken: 'Ya existe una ruta con ese nombre.',
      collectorMustBeActive: 'El cobrador tiene que ser parte activa del equipo.',
    },
    customers: {
      photoExpectedMultipart: 'La foto tiene que enviarse como archivo adjunto.',
      photoTooLarge: 'Esa foto es demasiado grande.',
      photoMissingFilePart: 'No vino ninguna foto en la solicitud.',
      photoNotStored: 'No se pudo guardar la foto: {reason}',
      firstNameRequired: 'Falta el nombre.',
      lastNameRequired: 'Falta el apellido.',
      codeNotAllocated: 'No se pudo asignar un código único. Intente de nuevo.',
      notFound: 'No se encontró al cliente.',
      zoneNotFound: 'No se encontró la zona.',
      riskScoreRange: 'El puntaje de riesgo va de 0 a 100.',
      zoneClosed: '«{name}» está cerrada y no toma clientes nuevos.',
    },
    admin: {
      requestVerified: 'La solicitud quedó verificada. El borrado es un paso aparte y explícito.',
      requestRejected: 'Solicitud rechazada.',
      trialNotExtended: 'No se pudo extender la prueba: {reason}',
      noAccountMatched: 'Ningún cuenta corresponde a esa dirección. La solicitud se cerró sin nada que borrar.',
      ownerNotFound: 'No se encontró al dueño.',
      platformAdminCannotDeactivate: 'Un administrador de la plataforma no se desactiva por la API.',
      ownerDeactivated: 'Dueño desactivado.',
      platformAdminCannotDelete: 'Una cuenta de administrador de la plataforma no se borra por la API.',
      noSubscription: 'Este dueño no tiene suscripción.',
      trialExtended: 'Se extendió la prueba.',
      subscriptionNotFound: 'No se encontró la suscripción.',
      premiumGranted: 'Se otorgó el acceso premium.',
      premiumReset: 'Se revirtió el acceso premium.',
      ownerReactivated: 'Dueño reactivado.',
      emailAlreadyVerified: 'Ese correo ya estaba verificado.',
      ownerHasNoEmail: 'El dueño no tiene correo.',
      verificationEmailSent: 'Se envió el correo de verificación.',
      deletionRequestNotFound: 'No se encontró la solicitud de borrado.',
      requestAlreadyReviewed: 'Esa solicitud ya se completó y no se revisa de nuevo.',
      ownerVerified: 'Dueño verificado.',
      requestAlreadyCompleted: 'Esa solicitud ya se completó.',
      onlyVerifiedCanComplete: 'Solo se completa una solicitud verificada. Verifique primero quién la pide.',
    },
    loanTables: {
      codeRequired: 'Falta el código de la tabla.',
      nameRequired: 'Falta el nombre de la tabla.',
      countryRequired: 'Falta el país.',
      installmentsPositive: 'Las cuotas tienen que ser un número positivo.',
      rateNotNegative: 'La tasa no puede ser negativa.',
      optionIncomplete: 'Cada monto necesita capital, cuota y total, todos positivos.',
      optionBelowPrincipal: 'Un monto no puede totalizar menos que su capital.',
      codeTakenByRetired: 'Ese código es de una tabla retirada. Elija otro.',
      codeTaken: 'Ya existe una tabla con ese código.',
      notFound: 'No se encontró la tabla.',
      systemCannotDelete: 'Una tabla del sistema no se puede borrar.',
      alreadyRetired: 'Esa tabla ya está retirada.',
      systemCannotEdit: 'Una tabla del sistema no se puede editar.',
    },
    devices: {
      linked: 'Dispositivo vinculado.',
      fingerprintRequired: 'Falta la huella del dispositivo.',
      notFound: 'Este dueño no tiene ese dispositivo.',
      alreadyRevoked: 'Ese dispositivo ya estaba revocado.',
      revoked: 'Dispositivo revocado.',
    },
    accountDeletion: {
      exportRequired: 'Antes de borrar la cuenta hay que ofrecer y completar la exportación o el respaldo.',
      confirmationRequired: 'Falta confirmar el borrado.',
      mustAcknowledgeCancellation: 'El usuario tiene que reconocer que cancelar la suscripción es aparte de borrar la cuenta.',
      retentionPolicyPending: '{reason}',
      ownerNotFound: 'No se encontró la cuenta del dueño.',
      onlyOwnerMayDelete: 'Solo el dueño del negocio puede borrarlo. Pídale a él que le quite el acceso.',
      completed: 'La cuenta quedó borrada.',
      emailRequired: 'Hace falta el correo para verificar a mano.',
      captchaFailed: 'No se pudo verificar el CAPTCHA.',
      emailInvalid: 'Hace falta un correo válido para verificar a mano.',
      requestSubmitted: 'La solicitud de borrado quedó enviada para verificarse a mano.',
    },
    publicForms: {
      waitlistFieldsRequired: 'Hacen falta el correo y el país.',
      contactFieldsRequired: 'Hacen falta el nombre, el correo y el mensaje.',
      captchaFailed: 'No se pudo verificar el CAPTCHA.',
      consentRequired: 'Hace falta su consentimiento para avisarle.',
      contactReceived: 'Recibimos su mensaje.',
      waitlistReceived: 'Quedó anotado en la lista de espera.',
    },
    commissions: {
      noBands: 'Un esquema sin tramos no paga nada. Si quiere dejar de pagar comisión, bórrelo.',
      firstBandDoesNotStartAtZero: 'El primer tramo tiene que arrancar en cero, o lo cobrado por debajo no gana nada sin que nadie lo haya decidido.',
      twoBandsStartAtTheSameFigure: 'Hay dos tramos que arrancan en la misma cifra, así que no se sabe cuál de las dos tasas aplica.',
      bandStartsBelowZero: 'Un tramo no puede arrancar por debajo de cero.',
      rateIsNotAPercentage: 'La tasa es un porcentaje entre 0 y 100.',
    },
    collections: {
      descriptionRequired: 'Falta la descripción.',
      amountMustBePositive: 'El monto tiene que ser positivo.',
      loanNotFound: 'No se encontró el préstamo.',
    },
    settings: {
      businessNameRequired: 'Falta el nombre del negocio.',
      phoneRequired: 'Falta el teléfono.',
      countryNotSupported: 'Ese país no está soportado.',
      fieldTooLong: '«{field}» es demasiado largo.',
    },
    accounting: {
      impairmentPolicySaved: 'Se guardó la política de deterioro.',
      impairmentUnknownBand: 'Ese no es uno de los tramos de antigüedad.',
      impairmentPercentRange: 'La parte de un tramo va de 0 a 100.',
      impairmentPolicyIncomplete: 'Cada tramo necesita su porcentaje antes de asentar; un tramo sin responder no es lo mismo que uno en cero.',
      impairmentAccountsMissing: 'El motor no tiene cuenta para la estimación o la pérdida; apúntelas primero.',
      impairmentNothingToPost: 'La estimación ya está donde debe.',
      impairmentPosted: 'Deterioro asentado.',
      importRowNoNumber: 'Esta fila no trae número de cuenta.',
      importNotANumber: '«{code}» no es un número de cuenta.',
      importNoName: '{code} no tiene nombre.',
      importDuplicate: '{code} aparece más de una vez.',
      importUnknownClass: '«{stated}» no es una clase de cuenta.',
      importNoClass: '{code} no dice de qué clase es, y su número queda fuera de la convención 1–7.',
      importChildOtherClass: '{code} cuelga de {mother}, que es de otra clase.',
      importNothingToImport: 'No hay nada para importar.',
      importClassConflict: '{code} ya existe con otra clase; se dejó como estaba.',
      account: {
        needsName: 'La cuenta necesita un nombre.',
        notYours: 'Esa cuenta no es de este negocio.',
        nameTaken: 'Ya hay otra cuenta llamada «{name}».',
        opened: 'Se abrió «{name}».',
        saved: 'Se guardó «{name}».',
        motherHidden: '«{name}» está oculta; no cuelga nada de ella.',
        hiddenForExpense: '«{name}» está oculta; no se le carga nada nuevo.',
        hiddenForEntry: '«{name}» está oculta; no se le asienta nada nuevo.',
        hiddenForEngine: '«{name}» está oculta; el motor no escribe en nada oculto.',
        controlForExpense: '«{name}» agrupa otras cuentas; cargue esto a una de las que cuelgan de ella.',
        controlForEntry: '«{name}» agrupa otras cuentas; asiente esto en una de las que cuelgan de ella.',
        controlForEngine: '«{name}» agrupa otras cuentas; apunte esto a una de las que cuelgan de ella.',
        keptByTheBook: '«{name}» la lleva el libro solo; cargue esto a una cuenta suya.',
      },
      expense: {
        needsPositiveAmount: 'Un gasto es un monto positivo.',
        needsDescription: 'Diga en qué se fue el dinero.',
        needsExpenseAccount: 'Elija la cuenta de gasto a la que se carga.',
        needsFundingSource: 'Elija de qué fuente salió el dinero.',
        recorded: 'Gasto registrado.',
      },
      entry: {
        needsDescription: 'Diga de qué se trata el asiento.',
        needsTwoLines: 'Un asiento lleva al menos dos líneas.',
        lineNegative: 'Una línea no puede llevar un monto negativo.',
        lineBothSides: 'Una línea va al debe o al haber, nunca a los dos.',
        lineMovesNothing: 'Una línea que no mueve nada no es una línea.',
        beyondCents: 'Los montos se llevan al centavo.',
        unbalanced: 'El debe ({debits}) y el haber ({credits}) tienen que cuadrar.',
        movesNothing: 'Un asiento que no mueve nada no es un asiento.',
        needsTwoAccounts: 'Un asiento mueve entre dos cuentas distintas.',
        accountsNotYours: 'Elija cuentas de su propio catálogo.',
        inClosedPeriod: 'Ese mes ya está cerrado. Use una fecha del período abierto.',
        posted: 'Asiento registrado.',
      },
      period: {
        closed: 'Período cerrado.',
        reopened: 'Período reabierto.',
        alreadyClosed: 'Ese período ya está cerrado.',
        notYetOver: 'No se puede cerrar un día que todavía no terminó.',
        noSigner: 'Su usuario no está activo en este negocio.',
        nothingToReopen: 'No hay ningún período cerrado para reabrir.',
      },
      engine: {
        identityUnknown: 'Ninguna regla registra con ese nombre.',
        accountNotYours: 'Elija una cuenta de su propio catálogo.',
        alreadyThere: '«{name}» ya la lleva.',
        wrongClass: '«{name}» no es de la clase que corresponde; el libro dejaría de cuadrar.',
        accountTaken: 'En «{name}» ya registra otra regla ({rule}); libérela primero.',
        nobodyCarriesIt: 'Ninguna cuenta la lleva ahora mismo.',
        moved: 'El motor ya registra {rule} en «{name}».',
      },
      import: {
        fixFileFirst: 'Corrija el archivo primero; no se importó nada.',
        nothingWritten: 'Todavía no se escribió nada.',
        done: 'Se agregaron {added} cuentas y se renombraron {renamed}.',
      },
    },
  },
  finance: {
    query: {
      search: 'Buscar en los movimientos',
      anyAccount: 'Cualquier cuenta',
      showing: '{count} movimiento | {count} movimientos',
    },
    income: 'Ingresos',
    costs: 'Costos',
    expenses: 'Gastos',
    assets: 'Activos',
    liabilities: 'Pasivos',
    equity: 'Patrimonio',
    profit: 'Ganancia del período',
    loss: 'Pérdida del período',
    ties: 'El libro cuadra',
    doesNotTie: 'El libro no cuadra por',
    result: {
      title: 'Resultado',
      hint: 'Lo que el negocio ganó contra lo que gastó.',
    },
    statement: {
      title: 'Estado de resultados',
      hint: 'Cuenta por cuenta, lo que entró contra lo que salió.',
      empty: 'El catálogo todavía no tiene cuentas de ingreso ni de gasto.',
    },
    position: {
      title: 'Posición',
      hint: 'Lo que el negocio tiene contra lo que debe.',
      asOf: 'Al {date}',
      today: 'A hoy',
    },
    period: {
      all: 'Todo el libro',
      span: '{from} – {to}',
      since: 'Desde el {from}',
      until: 'Hasta el {to}',
      up: '{amount} más que {period}',
      down: '{amount} menos que {period}',
      flat: 'Igual que {period}',
      quick: {
        thisMonth: 'Este mes',
        lastMonth: 'Mes pasado',
        thisYear: 'Este año',
        all: 'Todo',
      },
    },
  },
  accounting: {
    title: 'Finanzas',
    hint: 'Cada movimiento sale de lo que pasó en la calle. Acá se consulta y se compara.',
    notPurchased:
      'Tu plan todavía no incluye contabilidad. Igual venimos registrando cada desembolso y cada cobro: el día que la actives, tus libros aparecen completos desde el primer préstamo.',
    balances: 'Saldos',
    entries: 'Asientos',
    account: 'Cuenta',
    accountName: 'Nombre',
    debits: 'Debe',
    credits: 'Haber',
    balance: 'Saldo',
    debit: 'debe',
    credit: 'haber',
    date: 'Fecha',
    from: 'Desde',
    to: 'Hasta',
    description: 'Concepto',
    lines: 'Movimientos',
    hidden: 'Oculta',
    showHidden: 'Ver las ocultas',
    visible: 'Visible',
    visibleHint: 'Una cuenta oculta deja de aparecer en las listas, pero conserva todo lo que ya tiene asentado. Nunca se borra.',
    editAccount: 'Editar cuenta',
    emptyChart: 'Todavía no hay cuentas.',
    emptyEntries: 'Todavía no hay asientos en este rango.',
    saved: 'Cuenta guardada.',
    saveFailed: 'No se pudo guardar la cuenta.',
    expenses: 'Gastos',
    expensesTotal: 'Total',
    emptyExpenses: 'Todavía no hay gastos en este rango.',
    recordExpense: 'Registrar gasto',
    expenseRecorded: 'Gasto registrado.',
    expenseFailed: 'No se pudo registrar el gasto.',
    amount: 'Monto',
    expenseDescriptionPlaceholder: 'Gasolina de la moto, comisión del cobrador, alquiler…',
    expenseAccount: 'Se carga a',
    expenseAccountPlaceholder: 'Elija la cuenta de gasto',
    noExpenseAccounts: 'Todavía no tiene cuentas de gasto. Abra una con el botón de al lado — por ejemplo "Combustible" o "Comisiones".',
    paidFrom: 'Salió de',
    paidFromPlaceholder: 'Elija de qué fuente salió el dinero',
    newExpenseAccount: 'Nueva cuenta',
    newExpenseAccountPlaceholder: 'Combustible, Comisiones, Alquiler…',
    newExpenseAccountHint: 'Es suya: la puede renombrar u ocultar cuando quiera. Una cuenta sin madre queda como gasto, y es a esas a las que se cargan los gastos que registre.',
    motherAccount: 'Cuenta madre',
    motherAccountPlaceholder: 'Ninguna — queda suelta, como cuenta de gasto',
    motherAccountHint: 'La cuenta hereda la CLASE de su madre, así que esto decide de qué lado del balance cae. Sin madre queda como gasto.',
    motherBecomesTotal: '«{name}» pasa a totalizar lo que cuelgue debajo y deja de recibir movimientos propios.',
    motherBecomesTotalWithBalance: '«{name}» pasa a totalizar lo que cuelgue debajo. Los {amount} que tiene hoy se mudan a una subcuenta nueva con su mismo nombre, por un asiento con fecha — no es un renombre.',
    fiscalCode: 'Número fiscal',
    fiscalCodePlaceholder: '110204 — opcional, lo elige su contador',
    chart: {
      systemTab: 'Cuentas del sistema',
      accountantTab: 'El catálogo de su contador',
    },
    import: {
      action: 'Importar catálogo',
      title: 'Importar catálogo de cuentas',
      hint: 'Traiga el catálogo de su contador. Nunca se borra nada: las cuentas que faltan se agregan y las que ya existen toman el nombre del archivo. La clase de una cuenta que ya tiene movimientos no se cambia nunca.',
      paste: 'Pegue el catálogo',
      placeholder: '1101,Efectivo y equivalentes\n110101,Caja general\n110103,Bancos',
      formatHint: 'Una cuenta por línea: número, nombre y —si quiere— la clase (Activo, Pasivo, Patrimonio, Ingreso, Costo, Gasto, Orden). Sin la clase se toma del primer dígito. Sirven coma, punto y coma o tabulación.',
      check: 'Ver qué haría',
      apply: 'Importar',
      willCreate: 'Agrega {count} cuentas',
      willRename: 'renombra {count}',
      problems: 'Hay que corregir el archivo antes de importar:',
      conflicts: 'Estas se dejan como están:',
      line: 'Línea {line}',
      failed: 'No se pudo leer el catálogo.',
    },
    periodClose: {
      title: 'Cierre de períodos',
      hint: 'Un período cerrado no vuelve a cambiar. Un pago que entre con fecha de un mes cerrado conserva el día en que se movió el dinero y cuenta en el primer mes abierto.',
      through: 'Cerrar hasta',
      close: 'Cerrar período',
      reopen: 'Reabrir',
      closedThrough: 'Los libros están cerrados hasta el {date}.',
      nothingClosed: 'Todavía no hay ningún período cerrado.',
      notCloseable: 'Esa fecha no se puede cerrar: ya está cubierta por un cierre, o el día todavía no terminó.',
      none: 'Ningún período cerrado.',
      range: 'Período',
      state: 'Estado',
      signedBy: 'Cerrado por',
      openedBy: 'Reabierto por',
      closedTag: 'Cerrado',
      reopenedTag: 'Reabierto',
      unknownSigner: 'Sin identificar',
      reopenWarning: 'Se va a reabrir el período del {from} al {to}. Los asientos que habían pasado al mes abierto vuelven a su propia fecha, y las cifras ya reportadas de ese mes cambian.',
      loadFailed: 'No se pudieron cargar los períodos.',
      closed: 'Período cerrado.',
      closeFailed: 'No se pudo cerrar el período.',
      reopenFailed: 'No se pudo reabrir el período.',
      reopenedCount: 'Período reabierto. Asientos devueltos a su fecha: {count}.',
    },
    impairment: {
      title: 'Deterioro de cartera',
      hint: 'Lo que el libro no espera cobrar. Los porcentajes son SUYOS: el sistema los aplica a la cartera vencida y le muestra el estimado, pero no opina cuáles deben ser. Se asienta solo la diferencia contra lo ya provisionado.',
      band: 'Tramo',
      daysLate: '{label} días',
      portfolio: 'Cartera',
      percent: '%',
      estimated: 'Estimado',
      required: 'Requerido',
      provisioned: 'Ya provisionado',
      movement: 'A asentar hoy',
      incomplete: 'Falta el porcentaje de algún tramo. Un tramo sin responder no es un tramo en cero: guárdelo antes de asentar.',
      accountsMissing: 'Su catálogo no tiene las cuentas de deterioro. Reasígnelas en «A dónde escribe el motor».',
      savePolicy: 'Guardar porcentajes',
      saved: 'Porcentajes guardados.',
      saveFailed: 'No se pudieron guardar los porcentajes.',
      post: 'Asentar',
      posted: 'Deterioro asentado.',
      postFailed: 'No se pudo asentar el deterioro.',
    },
    engine: {
      title: 'A dónde escribe el motor',
      hint: 'Once reglas registran solas lo que pasa en la calle. Acá se dice en qué cuenta de SU catálogo cae cada una. Cambiar una arrastra el saldo con un asiento fechado.',
      rule: 'Regla',
      postsTo: 'Registra en',
      change: 'Cambiar',
      nowhere: 'Sin cuenta',
      moved: 'El motor ya registra en la cuenta nueva.',
      failed: 'No se pudo cambiar la cuenta del motor.',
      movingHint: '«{rule}» hoy cae en «{account}». Lo que esa cuenta tenga se muda a la nueva con un asiento fechado — no se reescribe nada de lo ya asentado.',
      noCandidates: 'No hay ninguna cuenta suya de esa clase todavía. Abra una primero: una regla solo puede caer en una cuenta de movimiento de la misma clase.',
      dateHint: 'La fecha del asiento de reclasificación. Es el día en que usted decide el cambio, no el de los movimientos viejos.',
      codes: {
        LOANS_RECEIVABLE: 'Préstamos por cobrar',
        CASH: 'Caja',
        BANK: 'Bancos',
        OPENING_BALANCES: 'Saldos de apertura',
        INTEREST_INCOME: 'Intereses ganados',
        MORA_INCOME: 'Mora cobrada',
        COLLECTION_FEES_INCOME: 'Cargos por gestión de cobro',
        DISCOUNTS_GRANTED: 'Descuentos otorgados',
        WRITE_OFFS: 'Préstamos castigados',
        IMPAIRMENT_ALLOWANCE: 'Estimación por deterioro',
        IMPAIRMENT_EXPENSE: 'Gasto por deterioro',
      },
      writes: {
        LOANS_RECEIVABLE: 'El capital que está en la calle: sube al desembolsar, baja al cobrar.',
        CASH: 'El efectivo de la caja.',
        BANK: 'El dinero en cuenta.',
        OPENING_BALANCES: 'Contra qué se abrió el libro el primer día.',
        INTEREST_INCOME: 'El interés, al cobrarlo.',
        MORA_INCOME: 'La mora, al cobrarla.',
        COLLECTION_FEES_INCOME: 'Los cargos por gestión, al cobrarlos.',
        DISCOUNTS_GRANTED: 'Lo que se decidió no cobrar.',
        WRITE_OFFS: 'El capital que no volvió.',
        IMPAIRMENT_ALLOWANCE: 'Lo que se estima no cobrar, restando de la cartera.',
        IMPAIRMENT_EXPENSE: 'La pérdida estimada, cargada al resultado del período.',
      },
    },
    kinds: {
      asset: 'Activo',
      liability: 'Pasivo',
      equity: 'Capital',
      income: 'Ingreso',
      expense: 'Gasto',
      cost: 'Costo',
      memorandum: 'Orden',
    },
    controlAccount: 'Agrupa subcuentas',
    newEntry: 'Nuevo asiento',
    newEntryHint:
      'Lo que la calle no produce sola: una provisión, una depreciación, un ajuste. Usted nombra las dos cuentas, así que el libro solo lo toma si cuadra.',
    entryDescriptionPlaceholder: 'Depreciación de agosto, provisión de nómina…',
    entryAccountPlaceholder: 'Busque por número o por nombre',
    addLine: 'Agregar línea',
    removeLine: 'Quitar la línea',
    difference: 'Diferencia',
    postEntry: 'Asentar',
    entryPosted: 'Asiento registrado.',
    entryFailed: 'No se pudo registrar el asiento.',
    manualEntry: 'Manual',
    raisedBy: {
      debit: 'Aumenta por el debe',
      credit: 'Aumenta por el haber',
    },
    entryProblem: {
      noDate: 'Ponga la fecha del asiento.',
      noDescription: 'Diga de qué se trata el asiento.',
      tooFewLines: 'Un asiento lleva al menos dos líneas: una sola no cuadra contra nada.',
      noAccount: 'Falta elegir la cuenta de una línea.',
      bothSides: 'Una línea va al debe o al haber, nunca a los dos.',
      noAmount: 'Falta el monto de una línea.',
      beyondCents: 'Los montos se llevan al centavo.',
      sameAccount: 'Las dos partidas caen en la misma cuenta: la cuenta queda donde estaba.',
      unbalanced: 'El debe y el haber todavía no cuadran.',
    },
  },
  fundingSources: {
    title: 'De dónde sale el dinero',
    hint: 'Cada desembolso nombra una. Agregue una por cada lugar del que saca efectivo — la caja, una cuenta, un socio.',
    create: 'Nueva fuente',
    edit: 'Editar fuente',
    emptyList: 'Todavía no hay ninguna fuente.',
    name: 'Nombre',
    kind: 'Tipo',
    status: 'Estado',
    loans: 'Préstamos',
    active: 'Activa',
    retired: 'Retirada',
    activeLabel: 'Disponible para desembolsar',
    retireHint:
      'Al retirarla deja de aparecer al desembolsar, pero se queda con los préstamos que ya pagó.',
    openingBalance: 'Saldo inicial',
    setOpening: 'Poner saldo inicial',
    openingTitle: 'Saldo inicial de {name}',
    openingHint:
      'Cuánto había en esta fuente el día que empezó el libro. Nadie lo contaba antes, así que la contabilidad no lo puede saber; sin este dato, cada desembolso deja la caja en negativo.',
    openingAmount: 'Monto',
    openingDate: 'Al día',
    openingOnce: 'Se dice una sola vez. Una corrección posterior es un asiento aparte, no un cambio de esta cifra.',
    openingSaved: 'Saldo inicial registrado.',
    openingFailed: 'No se pudo registrar el saldo inicial.',
    transfer: 'Traspaso',
    transferHint:
      'El mismo dinero cambia de bolsillo: la caja que se deposita en el banco, el banco del que se saca para la caja. No es un gasto ni un ingreso.',
    transferFrom: 'Sale de',
    transferTo: 'Entra a',
    transferPick: 'Elija una fuente',
    transferDate: 'Fecha',
    transferDescription: 'Concepto',
    transferDescriptionPlaceholder: 'Depósito de la semana',
    transferSaved: 'Traspaso registrado.',
    transferFailed: 'No se pudo registrar el traspaso.',
    contributed: 'Aportes',
    addMoney: 'Meter dinero',
    contributionTitle: 'Meter dinero a {name}',
    contributionHint:
      'Dinero suyo que entra a esta fuente después de abierta: el socio que pone más, el dueño que vuelve a llenar la caja. No sale de otra fuente ni es un ingreso del negocio.',
    contributionAmount: 'Monto',
    contributionDate: 'Fecha',
    contributionDescription: 'Concepto',
    contributionSaved: 'Aporte registrado.',
    contributionFailed: 'No se pudo registrar el aporte.',
    saved: 'Fuente guardada.',
    saveFailed: 'No se pudo guardar la fuente.',
    kinds: {
      Cash: 'Efectivo',
      Bank: 'Cuenta bancaria',
      Partner: 'Socio',
      Other: 'Otro',
    },
  },
  settings: {
    profile: {
      title: 'Mis datos',
      passwordTitle: 'Mi contraseña',
      firstName: 'Nombre',
      lastName: 'Apellido',
      phone: 'Teléfono',
      address: 'Dirección',
      addressHint: 'Opcional.',
      idNumber: 'Cédula',
      identityNote: 'El correo y la cédula los administra su negocio.',
      save: 'Guardar mis datos',
      changePhoto: 'Cambiar foto',
      removePhoto: 'Quitar foto',
      photoFailed: 'No se pudo guardar la foto.',
      saved: 'Se actualizaron sus datos.',
      failed: 'No se pudieron guardar sus datos.',
    },
    title: 'Configuración',
    save: 'Guardar',
    saved: 'Configuración guardada.',
    saveFailed: 'No se pudo guardar la configuración.',
    loadFailed: 'No se pudo cargar la configuración.',
    tabs: {
      profile: 'Negocio',
      promoters: 'Promotores',
      funding: 'Fondos',
      account: 'Cuenta',
      subscription: 'Suscripción',
    },
    businessProfile: {
      title: 'Perfil del negocio',
      hint: 'Lo que imprimen tus recibos y reportes.',
      notConfigured: 'Todavía sin configurar — estos son los mismos valores que imprime tu teléfono.',
    },
    fields: {
      businessName: 'Nombre del negocio',
      displayName: 'Tu nombre',
      phoneNumber: 'Teléfono',
      countryCode: 'País',
      email: 'Correo',
      slogan: 'Lema',
      addressLine: 'Dirección',
      receiptFooter: 'Pie del recibo',
    },
    toggles: {
      receiptTitle: 'En los recibos',
      receiptHint: 'Cada opción agrega o quita una línea del recibo impreso.',
      reportTitle: 'En los reportes',
      showBusinessNameOnReceipt: 'Nombre del negocio',
      showDisplayNameOnReceipt: 'Tu nombre',
      showPhoneOnReceipt: 'Teléfono',
      showSloganOnReceipt: 'Lema',
      showLoanStartDateOnReceipt: 'Fecha de inicio del préstamo',
      showLoanEndDateOnReceipt: 'Fecha de fin del préstamo',
      showInterestRateOnReceipt: 'Tasa de interés',
      showBusinessNameOnReports: 'Nombre del negocio',
      showDisplayNameOnReports: 'Tu nombre',
      showPhoneOnReports: 'Teléfono',
      showSloganOnReports: 'Lema',
    },
    password: {
      title: 'Cambiar contraseña',
      hint: 'Vas a tener que entrar de nuevo en tus otros dispositivos.',
      mustChangeHint: 'Su cuenta se creó con una contraseña temporal. Elija la suya antes de hacer cualquier otra cosa.',
      current: 'Contraseña actual',
      new: 'Contraseña nueva',
      confirm: 'Confirme la contraseña nueva',
      submit: 'Cambiar contraseña',
      mismatch: 'Las dos contraseñas nuevas no coinciden.',
      changed: 'Contraseña actualizada.',
      failed: 'No se pudo cambiar la contraseña.',
      otherDevices: 'Se cerraron tus otras sesiones.',
    },
    subscription: {
      title: 'Suscripción',
      hint: 'Tu plan StreetLoans Plus.',
      none: 'No hay suscripción registrada para este negocio.',
      status: 'Estado',
      plan: 'Plan',
      seats: 'Puestos',
      trialEnds: 'La prueba termina',
      periodEnds: 'El período termina',
      writes: 'Cambios',
      writesAllowed: 'Permitidos',
      writesBlocked: 'Solo lectura',
      manageOnPhone: 'Los planes se compran en la app del teléfono.',
      statuses: {
        Trialing: 'Prueba',
        Active: 'Activa',
        PastDue: 'Vencida',
        Canceled: 'Cancelada',
        Unknown: 'Desconocido',
      },
    },
  },
  paymentReview: {
    title: 'Pagos a revisar',
    emptyQueue: 'No hay nada para revisar.',
    reason: 'Motivo',
    collected: 'Cobrado',
    currentCap: 'Tope actual',
    submitted: 'Enviado',
    approve: 'Aprobar',
    reject: 'Rechazar',
    approveTitle: 'Aprobar pago',
    approveHint: 'Registre hasta {cap} (saldo actual más mora pendiente).',
    approvedAmount: 'Monto a registrar',
    rejectTitle: 'Rechazar pago',
    rejectReason: 'Motivo (obligatorio)',
    approved_success: 'Pago aprobado.',
    rejected_success: 'Pago rechazado.',
    actionFailed: 'No se pudo completar la decisión.',
    reasons: {
      ExceedsBalance: 'Supera el saldo',
      AlreadyPaid: 'Ya estaba paga',
    },
  },
  migration: {
    title: 'Importá tu cartera',
    hint: 'Traiga los clientes, préstamos y pagos de la app móvil de StreetLoans. Exporte un respaldo desde la app y suba el archivo aquí.',
    pickFile: 'Elegir archivo de respaldo',
    previewTitle: 'Qué contiene el respaldo',
    customers: 'Clientes',
    loans: 'Préstamos',
    installments: 'Cuotas',
    payments: 'Pagos',
    skippedLoans: 'Préstamos omitidos (archivados o en curso)',
    loansWithDefaultType: 'Préstamos importados con el tipo por defecto',
    oneWayWarning:
      'Esta importación se hace una sola vez sobre una cartera vacía. La plataforma recalcula la mora después de importar.',
    confirm: 'Importar cartera',
    successTitle: 'Cartera importada',
    requestFailed: 'No se pudo completar la importación. Intente de nuevo.',
    parseErrors: {
      'invalid-json': 'Ese archivo no es un respaldo válido (JSON corrupto).',
      'missing-data': 'Ese archivo no parece un respaldo de StreetLoans.',
    },
  },
  commissions: {
    title: 'Comisiones del cobrador',
    lede: 'Lo que el negocio le paga a cada cobrador sobre lo que trae. No es la gestión de cobro, que se le cobra al cliente.',
    notSetYet: 'Todavía no hay un esquema definido, así que hoy no se paga comisión. Armá los tramos, ensayalos contra lo ya cobrado y guardalos.',
    bandsTitle: 'Tramos',
    bandsNote: 'Los tramos son marginales, como el impuesto sobre la renta: pasar un umbral sube la tasa solo sobre el excedente. La base es capital más interés — la mora y la gestión de cobro no ganan comisión, porque crecen cuando el cliente se atrasa y es el cobrador quien decide cuándo visitarlo. Se gana al entregar la plata en caja, nunca al registrar el cobro: nada se debe sobre plata que sigue en la calle. La ventana es semanal.',
    from: 'Desde',
    rate: 'Tasa',
    addBand: 'Agregar tramo',
    removeBand: 'Quitar tramo',
    save: 'Guardar esquema',
    saved: 'Esquema guardado.',
    saveFailed: 'No se pudo guardar el esquema.',
    rehearsalTitle: 'Ensayo contra lo ya cobrado',
    rehearsalNote: 'Qué habría pagado este esquema sobre cobros que ya ocurrieron. Ensaya lo que está escrito arriba, esté guardado o no, y no escribe nada.',
    rangeFrom: 'Desde',
    rangeTo: 'Hasta',
    rehearse: 'Ensayar',
    rehearsalFailed: 'No se pudo calcular el ensayo.',
    collector: 'Cobrador',
    collected: 'Base cobrada',
    commission: 'Comisión',
    totalBase: 'Base total',
    totalCommission: 'Comisión total',
    nothingCollected: 'No hubo cobros en ese rango.',
    unknownCollector: 'Cobrador dado de baja',
  },
  loans: {
    title: 'Préstamos',
    code: 'Código',
    borrower: 'Cliente',
    principal: 'Capital',
    interestRate: 'Tasa de interés',
    installment: 'Cuota',
    total: 'Total a cobrar',
    outstanding: 'Debe',
    installmentsCount: '{count} cuotas',
    disbursed: 'Desembolsado',
    fundedFrom: 'El dinero salió de',
    fundedFromUnknown: 'No registrado',
    schedule: 'Cronograma',
    installments: 'Cuotas',
    number: '#',
    dueDate: 'Vencimiento',
    expected: 'Esperado',
    paid: 'Pagado',
    balance: 'Balance',
    status: 'Estado',
    view: 'Ver préstamo',
    paidTag: 'Pagada',
    pastDue: 'Vencida',
    pending: 'Pendiente',
    mora: 'Mora',
    pendingMora: 'Mora pendiente',
    daysOverdue: 'Días de atraso',
    daysCount: '{count} día | {count} días',
    emptyList: 'No se encontraron préstamos.',
    nobodyAssigned: 'Todavía no le asignaron clientes a su ruta. La oficina los asigna desde Rutas.',
    create: 'Nuevo préstamo',
    customer: 'Cliente',
    searchCustomer: 'Buscar cliente',
    type: 'Tipo de préstamo',
    frequencyLabel: 'Frecuencia',
    latePaymentRate: 'Tasa de mora',
    currency: 'Moneda',
    notes: 'Notas',
    created_success: 'Préstamo creado.',
    actionFailed: 'No se pudo crear el préstamo.',
    cancelLoan: 'Cancelar préstamo',
    cancelConfirm:
      'Esto cancelará el préstamo y lo excluirá de los reportes del negocio. Esta acción no se puede deshacer.',
    cancelReason: 'Motivo (opcional)',
    cancelled_success: 'Préstamo cancelado.',
    cancelFailed: 'No se pudo cancelar el préstamo.',
    types: {
      SIMPLE: 'Interés simple',
      FRENCH: 'Francés (amortizado)',
      GERMAN: 'Alemán (decreciente)',
      GOTA_GOTA: 'Gota a gota',
      IMPLIED_RATE: 'Tasa implícita',
    },
    frequency: {
      daily: 'diaria',
      weekly: 'semanal',
      biWeekly: 'quincenal',
      monthly: 'mensual',
    },
    frequencyOption: {
      daily: 'Diaria',
      weekly: 'Semanal',
      biWeekly: 'Quincenal',
      monthly: 'Mensual',
      unknown: 'Desconocida',
    },
    frequencyFallback: 'desconocida',
    statuses: {
      inProgress: 'En proceso',
      active: 'Activo',
      paidOff: 'Saldado',
      overdue: 'En atraso',
      cancelled: 'Cancelado',
    },
  },
  gotaGota: {
    pickPlan: 'Elija el plan',
    typeTermsInstead: 'Escribir los términos',
    flatRate: '{rate}% flat',
    amountCount: 'sin montos | 1 monto | {count} montos',
    howOften: '¿Cada cuánto cobra?',
    cadences: {
      daily: 'Diario',
      weekly: 'Semanal',
      biWeekly: 'Quincenal',
      monthly: 'Mensual',
    },
    scheduleHint: 'Cada día · {installments} | Cada {days} días · {installments}',
    installmentCount: '{count} cuota | {count} cuotas',
    pickAmount: 'Elija el monto',
    loadingAmounts: 'Cargando montos…',
    capital: 'Capital',
    perVisit: 'Cuota',
    summary: '{installments} de {installment} · {total} en total',
    totalLabel: 'en total',
  },
  loanCalculator: {
    title: 'Calculadora de préstamos',
    fromTable: 'Tarifar desde una tabla',
    chooseTable: 'Sin tabla — escriba los términos',
    tableAmount: 'Monto',
    chooseAmount: 'Elija un monto',
    monthlyRate: 'Tasa mensual',
    monthlyRateHint: 'Ingrese la tasa MENSUAL — se multiplica por 12 para obtener la tasa anual.',
    calculating: 'Calculando…',
    invalidParameters: 'Estos parámetros no generan un préstamo válido.',
    cadence: {
      daily: '{count} cuota diaria | {count} cuotas diarias',
      weekly: '{count} cuota semanal | {count} cuotas semanales',
      biWeekly: '{count} cuota quincenal | {count} cuotas quincenales',
      monthly: '{count} cuota mensual | {count} cuotas mensuales',
    },
    periodicPayment: 'Cuota periódica',
    totalAmount: 'Total a cobrar',
    totalInterest: 'Interés total',
    ear: 'Tasa efectiva anual',
    period: '#',
    paymentAmount: 'Cuota',
    interestPart: 'Interés',
    principalPart: 'Capital',
    remainingBalance: 'Balance',
  },
  collections: {
    title: 'Por cobrar hoy',
    refresh: 'Actualizar',
    visitOrder: 'Parada',
    dueToday: 'Vence hoy',
    emptyList: 'No hay nada por cobrar hoy.',
    nobodyAssigned: 'Todavía no le asignaron clientes a su ruta. La oficina los asigna desde Rutas.',
    chooseRoute: 'Elegir ruta',
    noRoute: 'Sin ruta',
    toCollect: 'Por cobrar',
    collectedToday: 'Cobrado hoy',
    visits: 'Visitas',
    collected: 'Cobrado',
    visitDone: 'Visita hecha',
    daysLate: '{count} día atrasado | {count} días atrasado',
    installmentShort: 'Cuota {number}',
  },
  collect: {
      waiveTitle: '¿Cuánto le perdona?',
      waiveNothing: 'No hay nada que perdonar en esta cuota.',
      waiveSummary: 'Perdona {waived} · cobra {cash}',
      waiveOf: {
        interest: 'Interés',
        mora: 'Mora',
        collectionFees: 'Cargos por gestión',
      },
    selectInstallments: 'Marque las cuotas que va a cobrar',
    owedToday: 'Debe hoy',
    owedParts: 'Cuota {balance} + mora {mora}',
    collectedAll: 'Cobró todo',
    collectedOther: 'Cobró otra cantidad',
    collectedOtherHint: 'abono o pago parcial',
    waiveLink: 'Descontar interés o mora',
    viewLoan: 'Ver préstamo completo',
    notPaidNext: 'No pagó hoy · siguiente',
    notPaidClose: 'No pagó hoy',
    howMuch: '¿Cuánto le pagó?',
    amountCollected: 'Monto cobrado',
    remaining: 'Queda pendiente {amount} de {owed}',
    tooHigh: 'No puede pasar de {owed}',
    backspace: 'Borrar',
    record: 'Registrar',
    collectedAmount: 'Cobrado {amount}',
    savedOffline: 'Guardado sin conexión: se enviará al reconectar',
    queuedForReview: 'Enviado a revisión de la oficina',
    stillOwes: 'Queda pendiente {amount}',
    installmentSettled: 'Cuota saldada',
    sendReceipt: 'Enviar recibo',
    sendReceiptHint: 'WhatsApp · compartir · imprimir',
    sendProvisionalReceipt: 'Enviar recibo provisional',
    sendProvisionalReceiptHint: 'sin conexión · con código para la oficina',
    nextCustomer: 'Siguiente cliente',
    backToList: 'Volver a la lista',
    owedPartsMulti: '{count} cuota + mora {mora} | {count} cuotas + mora {mora}',
    installmentsCollected: '{count} cuota cobrada | {count} cuotas cobradas',
    viewLoanReceiptsHint: 'los recibos de cada cuota están ahí',
  },
  provisionalReceipt: {
    dialogTitle: 'Recibo provisional',
    title: 'RECIBO DE PAGO',
    provisional: 'PROVISIONAL',
    pendingNote: 'Pendiente de confirmar por la oficina. Guarde este código.',
    code: 'Código',
    date: 'Fecha',
    customer: 'Cliente',
    loan: 'Préstamo',
    installment: 'Cuota',
    amount: 'Monto recibido',
    remaining: 'Resta de capital',
    collector: 'Cobrador',
    shareTitle: 'Recibo provisional',
    warning:
      'Sin conexión: este recibo es provisional. Su código {code} identifica el cobro; la oficina lo confirma cuando el teléfono se conecta.',
    signature: 'Firma',
    unsigned: 'Sin firma: el teléfono no tenía su clave al emitirlo.',
    signatureNote: 'Firma {signature}: la oficina puede comprobar que salió de esta app.',
    failed: 'No se pudo dibujar el recibo en este dispositivo.',
  },
  provisionalLookup: {
    title: 'Verificar recibo provisional',
    hint: 'Escriba el código de 8 caracteres y la fecha que trae el recibo que dio el cobrador sin conexión.',
    code: 'Código',
    date: 'Fecha del recibo',
    search: 'Verificar',
    recorded: 'Cobro registrado',
    queued: 'Cobro en revisión de la oficina',
    rejected: 'Cobro rechazado en revisión',
    missing: 'Ese cobro NO llegó al sistema. El cliente tiene un recibo de un pago que nadie reportó: pregunte al cobrador de esa fecha.',
    amount: 'Monto',
    signature: 'Firma',
    scan: 'Leer el QR del ticket',
    genuine: 'Recibo auténtico: salió de la app de {who}.',
    genuineButMissing:
      'Recibo AUTÉNTICO, emitido por la app de {who}, pero el pago NO llegó al sistema: ese cobrador tomó el dinero y no lo reportó.',
    forged: 'Firma INVÁLIDA: este recibo no salió del sistema o fue alterado (monto, fecha o código).',
    recordedBy: 'registrado por {who}',
  },
  myPayments: {
    title: 'Mis cobros',
    emptyList: 'No hay pagos registrados en este rango.',
    total: '1 cobro, total | {count} cobros, total',
  },
  cashClose: {
    title: 'Cierre de caja',
    box: 'Caja',
    chooseBox: 'Elija la caja',
    date: 'Fecha',
    expected: 'Según el libro',
    counted: 'Efectivo contado',
    short: 'Faltan {amount}. Queda registrado como faltante.',
    over: 'Sobran {amount}. Queda registrado como sobrante.',
    ties: 'La caja cuadra.',
    deposited: 'Depositado al banco',
    depositTo: 'Entró a',
    chooseBank: 'Elija la cuenta',
    remaining: 'Queda en caja: {amount}',
    depositBeyondCount: 'No puede depositar más de lo que contó.',
    notes: 'Notas',
    close: 'Cerrar la caja',
    closed: 'Caja cerrada.',
    failed: 'No se pudo cerrar la caja.',
    sharesGeneralAccount: 'Esta caja no tiene cuenta contable propia: comparte la cuenta de caja general con las demás, así que el libro no puede decir cuánto tiene ella sola. Ábrale una cuenta propia para poder cerrarla.',
  },
  loanTables: {
    title: 'Tablas gota a gota',
    create: 'Nueva tabla',
    editTitle: 'Editar tabla',
    edit: 'Editar tabla',
    code: 'Código',
    name: 'Nombre',
    country: 'País',
    system: 'Sistema',
    amountCount: 'Montos',
    amountOptions: 'Montos',
    addAmount: 'Agregar monto',
    removeAmount: 'Quitar monto',
    amount: 'Capital',
    installmentAmount: 'Por cuota',
    totalToPay: 'Total a pagar',
    noAmounts: 'Todavía no hay montos. Agregue uno para tarifar esta tabla.',
    retire: 'Retirar',
    retireTitle: 'Retirar tabla',
    retireConfirm:
      '¿Retirar la tabla «{code}»? Deja de aparecer en la lista, y los préstamos ya tarifados con ella siguen funcionando.',
    emptyList: 'Todavía no hay tablas.',
    created_success: 'Tabla creada.',
    updated_success: 'Tabla actualizada.',
    retired_success: 'Tabla retirada.',
    actionFailed: 'No se pudo completar la operación.',
    errors: {
      codeRequired: 'El código es obligatorio.',
      nameRequired: 'El nombre es obligatorio.',
      countryRequired: 'El país es obligatorio.',
      installmentsPositive: 'Las cuotas tienen que ser mayores a cero.',
      rateNonNegative: 'La tasa de interés no puede ser negativa.',
      optionPositive: 'Cada monto necesita capital, cuota y total positivos.',
      optionBelowPrincipal: 'Un monto no puede totalizar menos que su capital.',
    },
  },
  loanRequests: {
    disburse: {
      title: 'Desembolsar préstamo',
      fundingSource: 'El dinero sale de',
      fundingSourcePlaceholder: 'Elija una fuente',
      fundingSourceHint: 'De cuál de sus fuentes sale este dinero. Después nadie puede deducirlo.',
      zone: 'Se cobra en',
      zoneKept: 'Ya está en esta ruta: se queda con el cobrador que ya lo visita. Cambiarlo es un acto aparte, desde el cliente.',
      zonePlaceholder: 'Elija una ruta',
      zoneHint: 'Un cobrador solo ve los clientes de sus propias rutas. Fuera de una, nadie en la calle puede cobrar este préstamo.',
      fundingSourcesFailed: 'No se pudieron cargar sus fuentes de fondos, así que por ahora no se puede desembolsar nada.',
      action: 'Desembolsar',
      confirm: 'Desembolsar',
      date: 'Fecha de inicio',
      dateHint: 'El día en que el dinero salió de verdad. Todas las cuotas se cuentan desde aquí.',
      schedule: 'Cronograma de cuotas',
      quoteFailed: 'No se pudo calcular el cronograma con estos términos.',
      warning: 'Al confirmar se crea el préstamo y sale a la calle. No se puede deshacer.',
    },
    applicant: 'Cliente',
    applicantHint: 'Escriba primero la cédula — si ya le prestó antes, el resto se completa solo.',
    idNumberPlaceholder: 'Cédula',
    lookupSearching: 'Buscando esa cédula…',
    lookupFound: 'Ya está en tus libros ({code}). Se completaron sus datos.',
    customerNotes: 'Notas sobre el cliente',
    terms: 'Términos del préstamo',
    photoAfterApproval: 'Vas a poder adjuntar una foto cuando esta solicitud se apruebe y el cliente entre a tus libros.',
    title: 'Mis solicitudes',
    queueTitle: 'Solicitudes',
    create: 'Nueva solicitud',
    requested: 'Solicitado',
    status: 'Estado',
    decisionReason: 'Motivo de la decisión',
    approve: 'Aprobar',
    reject: 'Rechazar',
    rejectTitle: 'Rechazar solicitud',
    rejectReason: 'Motivo (opcional)',
    emptyList: 'Aún no hay solicitudes.',
    emptyQueue: 'No hay nada esperando aprobación.',
    created_success: 'Solicitud enviada para aprobación.',
    createFailed: 'No se pudo enviar la solicitud.',
    photo: 'Foto del cliente',
    attachPhoto: 'Adjuntar foto',
    photoUploadFailed: 'La solicitud se registró, pero no se pudo adjuntar la foto.',
    photoRejected: {
      type: 'Solo se aceptan imágenes PNG, JPEG y WEBP.',
      size: 'La foto no puede superar los 5 MB.',
    },
    approved_success: 'Solicitud aprobada — el préstamo fue creado.',
    rejected_success: 'Solicitud rechazada.',
    actionFailed: 'No se pudo completar la operación.',
    statuses: {
      Pending: 'Pendiente',
      Approved: 'Aprobada',
      Rejected: 'Rechazada',
    },
  },
  outbox: {
    pending: '{count} por sincronizar',
    pendingHint: 'Pagos guardados sin conexión, esperando llegar al servidor.',
  },
  subscription: {
    trialDaysLeft: 'Te quedan {count} días de prueba gratis.',
    readOnly: 'Tu suscripción está inactiva — los libros quedan en solo lectura. No se borra nada; renová para seguir trabajando.',
    unknown: 'No pudimos verificar tu suscripción. Mientras tanto no se puede guardar; no es que se haya vencido.',
    retry: 'Reintentar',
  },
  collectionActivities: {
    title: 'Visitas de cobranza',
    record: 'Registrar visita',
    date: 'Fecha',
    description: 'Descripción',
    amount: 'Gasto',
    outstanding: 'Pendiente',
    agreementNote: 'Acuerdo',
    settled: 'Saldada',
    pending: 'Pendiente',
    empty: 'No hay visitas registradas para este préstamo.',
    recorded_success: 'Visita registrada.',
    actionFailed: 'No se pudo completar la operación.',
    errors: {
      descriptionRequired: 'La descripción es obligatoria.',
      amountPositive: 'El gasto tiene que ser mayor a cero.',
      dateRequired: 'La fecha es obligatoria.',
    },
  },
  reports: {
    exportCsv: 'Exportar CSV',
    exportFailed: 'No se pudo exportar el reporte. Pruebe de nuevo.',
    exportEmpty: 'No se cobró nada en ese rango, así que no hay nada para exportar.',
    monthlyFlowTitle: 'Prestado vs recuperado',
    collectionsTrendTitle: 'Cobros en el período',
    collectedInWindow: 'cobrado en el rango elegido',
    noFlow: 'Todavía no hay movimiento que graficar.',
    topCustomersTitle: 'Principales deudores',
    disbursed: 'Prestado',
    recovered: 'Recuperado',
    outstanding: 'Pendiente',
    loanCount: 'Préstamos',
    noChartData: 'Todavía no hay nada para graficar.',
    noTopCustomers: 'No hay deudores con saldo pendiente.',
    months: {
      1: 'Ene', 2: 'Feb', 3: 'Mar', 4: 'Abr', 5: 'May', 6: 'Jun',
      7: 'Jul', 8: 'Ago', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dic',
    },
  },
  payments: {
    preview: {
      title: 'Se va a aplicar así',
      collectionFees: 'Gestión de cobro',
      mora: 'Mora',
      interest: 'Interés',
      principal: 'Capital',
      unapplied: 'Sobran {amount} que no tienen dónde aplicarse. El servidor va a rechazar el cobro.',
    },
    fundingSource: '¿Dónde entró el dinero?',
    chooseFundingSource: 'Elija la fuente',
    breakdownTitle: 'Desglose del pago',
    applied: 'Aplicado a',
    waived: 'Condonado',
    waivedNote: 'Lo condonado no forma parte del monto cobrado.',
    breakdownMismatch: 'Los rubros de abajo no suman el monto cobrado.',
    downloadReceipt: 'Recibo',
    receiptTitle: 'Recibo',
    receiptShare: 'Enviar',
    receiptShareTitle: 'Recibo de pago',
    receiptOpen: 'Ver o imprimir',
    receiptSave: 'Guardar',
    receiptShareUnsupported: 'Este navegador no puede pasarle el archivo a otra app. Guárdelo y adjúntelo usted.',
    receiptNotFound: 'Este pago no tiene recibo.',
    receiptFailed: 'No se pudo descargar el recibo. Pruebe de nuevo.',
    receiptServerFailed: 'El servidor no pudo generar el recibo. El pago está registrado; avise para revisarlo.',
    receiptUnreachable: 'No se pudo contactar el servidor para traer el recibo. Revise la conexión.',
    receiptEmpty: 'El servidor devolvió un recibo vacío. Avise para que lo revisen.',
    appliedToCollectionFees: 'Gastos de cobranza',
    discountInterest: 'Interés',
    discountMora: 'Mora',
    discountCollectionFees: 'Gastos de cobranza',
    discounts: 'Descuentos',
    discountAvailable: 'Disponible: {amount}',
    discountsUnavailable: 'No se pudieron consultar los montos disponibles. Puede registrar el pago sin descuentos.',
    cashDue: 'A cobrar en efectivo',
    record: 'Registrar pago',
    history: 'Historial de pagos',
    date: 'Fecha',
    amount: 'Monto',
    appliedToInterest: 'A intereses',
    appliedToPrincipal: 'A capital',
    appliedToMora: 'A mora',
    receipt: 'Recibo',
    amountPlaceholder: 'Lo que entregó',
    debtUnavailable: 'No se pudo cargar el detalle de la deuda. Puede registrar el pago igual.',
    debt: {
      title: 'Debe en total',
      installments: 'Ver {count} cuotas pendientes',
      overdueCount: '{count} vencidas',
    },
    notes: 'Notas',
    recorded_success: 'Pago registrado.',
    savedOffline: 'Guardado sin conexión — se sincroniza cuando vuelvas a conectarte.',
    queuedForReview: 'Guardado y enviado a revisión (supera el saldo o la cuota ya estaba paga).',
    actionFailed: 'No se pudo registrar el pago.',
    emptyHistory: 'Aún no hay pagos registrados.',
  },
  customers: {
    title: 'Clientes',
    search: 'Buscar clientes',
    create: 'Nuevo cliente',
    code: 'Código',
    name: 'Nombre',
    firstName: 'Nombre',
    lastName: 'Apellido',
    nickName: 'Apodo',
    idNumber: 'Cédula',
    newLoan: 'Nuevo préstamo',
    phone: 'Teléfono',
    email: 'Correo',
    address: 'Dirección',
    reference: 'Referencia',
    notes: 'Notas',
    status: 'Estado',
    active: 'Activo',
    inactive: 'Inactivo',
    blacklisted: 'En lista negra',
    created_success: 'Cliente creado.',
    updated_success: 'Cliente actualizado.',
    actionFailed: 'No se pudo completar la operación.',
    zone: 'Ruta',
    noZone: 'Sin ruta',
    noZoneHint: 'Ningún cobrador pasa por este cliente hasta que esté en una ruta.',
    changeZone: 'Cambiar ruta',
    placeInZone: 'Poner en una ruta',
    zoneDialogTitle: 'Ruta de {name}',
    zonePlaceholder: 'Elija la ruta que lo cobra',
    zoneAppendedHint: 'Queda al final del recorrido de esa ruta; el orden se ajusta desde la ruta.',
    removeFromZone: 'Quitar de la ruta',
    zoneNoneOpen: 'No hay rutas abiertas. Cree una en Rutas primero.',
    zone_updated_success: 'Ruta actualizada.',
    emptyList: 'No se encontraron clientes.',
    view: 'Ver cliente',
    edit: 'Editar cliente',
    save: 'Guardar cambios',
    riskScore: 'Puntaje de riesgo',
  },
  recovery: {
    forgot: '¿Olvidó su contraseña?',
    title: 'Recuperar su acceso',
    hint: 'Escriba su correo y le enviaremos un enlace para crear una contraseña nueva.',
    submit: 'Enviar el enlace',
    sentTitle: 'Revise su correo',
    sentBody: 'Si {email} tiene una cuenta, le llegó un enlace para crear una contraseña nueva. Vence en una hora.',
    backToLogin: 'Volver al inicio de sesión',
    sendAgain: 'Enviar de nuevo',
    sendAgainIn: 'Puede enviarlo de nuevo en {seconds}s',
    changeEmail: 'Usar otra dirección',
    resetTitle: 'Crear una contraseña nueva',
    resetHint: 'Elija una contraseña de al menos 10 caracteres.',
    newPassword: 'Contraseña nueva',
    confirmPassword: 'Confirmar contraseña',
    mismatch: 'Las contraseñas no coinciden.',
    noToken: 'Falta el enlace. Abra el que le llegó por correo.',
    failed: 'No se pudo cambiar la contraseña.',
    doneTitle: 'Su contraseña quedó cambiada',
    doneBody: 'Ya puede entrar con su contraseña nueva. Por seguridad, se cerraron sus otras sesiones.',
    resetSubmit: 'Cambiar mi contraseña',
  },
  login: {
    failure: {
      credentials: 'Credenciales inválidas.',
      throttled: 'Demasiados intentos seguidos. Espere un minuto y vuelva a probar — la contraseña puede estar bien.',
      unreachable: 'No se pudo contactar el servidor. Revise su conexión.',
      serverError: 'El servidor respondió con un error. No es su contraseña — vuelva a intentar en un momento.',
      deviceUnidentified: 'Este navegador no pudo identificarse. Salga del modo privado o permita el almacenamiento del sitio, y vuelva a intentar.',
    },
    title: 'StreetLoans',
    formTitle: 'Bienvenido',
    formHint: 'Entre con el correo y la contraseña de su cuenta.',
    tagline: 'Su operación de crédito, completa.',
    platformTagline: 'Administración del producto.',
    rememberMe: 'Recordar mi correo',
    madeBy: 'Un producto de PinotechRD LLC',
    features: {
      portfolio: 'Préstamos y cartera',
      collectors: 'Cobradores en ruta, con recibo firmado',
      cash: 'Caja, cierres y comisiones',
      accounting: 'Contabilidad con estados financieros',
      reports: 'Reportes y riesgo de cartera',
    },
    email: 'Correo electrónico',
    password: 'Contraseña',
    submit: 'Iniciar sesión',
    failed: 'Credenciales inválidas.',
    platformTitle: 'Consola de plataforma',
    platformHint: 'Administración del producto. Aquí solo entra el operador de la plataforma.',
    platformOnly: 'Esa cuenta pertenece a un negocio, no a la plataforma. Entre por el acceso de su negocio.',
    goToBusinessLogin: 'Ir al acceso del negocio',
  },
  dashboard: {
    headline: {
      collected: 'Cobrado en el período',
      collectedNote: 'Capital, intereses y mora que volvieron.',
      outstandingNote: 'En {count} préstamos en la calle.',
      atRiskNote: 'Cartera en riesgo +30 días: {percent}.',
      atRiskShortNote: 'Capital vencido que todavía no ha vuelto.',
    },
    loansOnTheStreet: 'Préstamos en la calle',
    loansWithOutstandingBalance: 'Préstamos con saldo',
    risk: {
      title: 'Salud de la cartera',
      par30: 'Cartera en riesgo (+30 días)',
      par30Hint: 'Todo el saldo de los préstamos con más de 30 días de atraso, sobre {portfolio} en la calle.',
      efficiency: 'Eficiencia de cobro',
      efficiencyHint: 'Cobrado contra lo que el cronograma decía que vencía en el período: {expected}.',
      efficiencyOver: 'Pasa de 100% porque entró más de lo que vencía: alguien adelantó o se puso al día.',
      interestInArrears: 'Intereses en atraso',
      waived: 'Condonado en el período',
      waivedSplit: 'Intereses {interest} · Mora {mora} · Cargos {fees}',
      agingTitle: 'Antigüedad de la mora',
      agingHint: 'Cuánto capital e interés hay vencido, según cuántos días lleva vencido.',
      daysLate: 'Días de atraso',
      principal: 'Capital',
      interest: 'Interés',
      total: 'Total',
    },
    title: 'Estado del negocio',
    from: 'Desde',
    to: 'Hasta',
    apply: 'Aplicar',
    clear: 'Limpiar',
    rangeHint:
      'El rango de fechas filtra solo los cobros; el capital prestado es siempre histórico.',
    movement: {
      title: 'Movimiento del período',
    },
    size: {
      title: 'Tamaño de la cartera',
    },
    capitalLent: 'Capital prestado',
    capitalRecovered: 'Capital recuperado',
    capitalOutstanding: 'Capital pendiente',
    interestCollected: 'Intereses cobrados',
    capitalInArrears: 'Capital en atraso',
    moraCollected: 'Mora cobrada',
    collectionFeesCollected: 'Gastos de cobranza cobrados',
  },
  common: {
    close: 'Cerrar',
    actionFailed: 'No se pudo completar la operación.',
    actions: 'Acciones',
    notAvailable: 'No disponible',
    yes: 'Sí',
    no: 'No',
    confirm: 'Confirmar',
    back: 'Atrás',
    cancel: 'Cancelar',
    save: 'Guardar',
    search: 'Buscar',
    refresh: 'Actualizar',
    dismiss: 'Descartar',
    loadFailed: 'No se pudieron cargar los datos.',
    loading: 'Cargando…',
    writeDisabledReason: {
      loading: 'Comprobando permisos…',
      readOnly: 'No disponible: tu suscripción está en modo solo lectura.',
      unknown: 'No disponible: no pudimos verificar tu suscripción.',
      forbidden: 'No tiene permiso para hacer esto.',
    },
  },
  qr: {
    title: 'Leer el QR del recibo',
    hint: 'Apunte la cámara al código del ticket.',
    unsupported: 'Este navegador no puede leer códigos. Escriba los datos a mano.',
    noCamera: 'No se pudo abrir la cámara. Permita el acceso o escriba los datos a mano.',
  },
  promoters: {
    title: 'Comisión de promotores',
    lead: 'Lo que el negocio le paga a quien le trae los préstamos.',
    houseRate: 'Comisión del negocio',
    houseRateHint: 'Puntos de la tasa del préstamo. Vacío significa que cada promotor se acuerda aparte.',
    frozenNote: 'La comisión queda fija en cada préstamo al desembolsar. Cambiar esta cifra solo afecta los préstamos nuevos.',
    saved: 'Comisión guardada.',
    saveFailed: 'No se pudo guardar la comisión.',
    none: 'Sin promotor',
    pick: 'Promotor',
    pickHint: 'Quien trajo este préstamo. Su comisión queda fija al desembolsar.',
    rateFor: 'Le tocaría {points} pts',
    overrideRate: 'Comisión para este préstamo',
    exceedsRate: 'Esa comisión pasa la tasa del préstamo ({rate} pts). Ponga una menor o desembolse sin promotor.',
    fromLoan: 'de este préstamo',
    fromPromoter: 'su propia tasa',
    fromHouse: 'del negocio',
    notConfigured: 'Sin comisión configurada',
  },
  permissions: {
    title: 'Permisos de {name}',
    lead: 'Su rol decide por defecto. Acá se ajusta persona por persona, sin inventarle un rol propio.',
    open: 'Permisos',
    inherit: 'Según su rol',
    allow: 'Permitir',
    deny: 'Negar',
    fromRole: 'Su rol lo trae',
    saved: 'Permisos guardados.',
    saveFailed: 'No se pudieron guardar los permisos.',
    loadFailed: 'No se pudieron cargar los permisos.',
  },
  pwa: {
    offlineReady: 'Lista para trabajar sin conexión.',
    updateAvailable: 'Hay una versión nueva disponible.',
    install: 'Instalar la app',
    stepsLead: 'Su navegador no nos deja instalarla con un toque, pero usted sí puede hacerlo desde su menú:',
    stepsWhy: 'Instalada abre a pantalla completa, arranca más rápido y sigue funcionando donde no hay señal.',
    steps: {
      android: [
        'Toque los tres puntos ⋮ arriba a la derecha.',
        'Elija "Agregar a la pantalla principal" o "Instalar aplicación".',
        'Confirme con "Instalar".',
      ],
      ios: [
        'Toque el botón Compartir, el cuadrado con la flecha hacia arriba.',
        'Baje y elija "Agregar a inicio".',
        'Confirme con "Agregar".',
      ],
      desktop: [
        'Busque el ícono de instalar en la barra de direcciones, a la derecha.',
        'Si no aparece, abra el menú del navegador y elija "Instalar".',
        'Confirme con "Instalar".',
      ],
    },
    updateWhy: 'Actualice ahora. Cobrar con una versión vieja puede aplicar reglas que ya cambiaron.',
    update: 'Actualizar',
  },
  forbidden: {
    title: 'Sin acceso',
    message:
      'Tu cuenta no tiene permiso para ver esta sección. Consulte con su administrador si cree que es un error.',
  },
  roles: {
    title: 'Roles',
    create: 'Nuevo rol',
    name: 'Nombre',
    system: 'Sistema',
    unscoped: 'Sin alcance',
    permissionCount: 'Permisos',
    members: 'Miembros',
    edit: 'Editar rol',
    delete: 'Eliminar rol',
    createTitle: 'Nuevo rol',
    editTitle: 'Editar rol',
    unscopedHint: 'Ve todas las filas del tenant (no se limita a sus rutas)',
    basicInfo: 'Información básica',
    privileges: 'Privilegios',
    permissionGroups: {
      accounting: 'Contabilidad',
      customers: 'Clientes',
      loans: 'Préstamos',
      loanRequests: 'Solicitudes',
      loanTables: 'Tablas',
      settings: 'Configuración',
      payments: 'Pagos',
      routes: 'Rutas',
      users: 'Usuarios',
      reports: 'Reportes',
      migration: 'Migración',
      general: 'Otros',
    },
    permissionActions: {
      accounting: { post: 'Asentar en el libro' },
      customers: { view: 'Ver', manage: 'Gestionar', photo: 'Adjuntar foto' },
      loanTables: { manage: 'Crear y editar tablas' },
      settings: { manage: 'Cambiar la configuración' },
      loans: { view: 'Ver', list: 'Listar todos', create: 'Crear', cancel: 'Cancelar' },
      loanRequests: { create: 'Crear', approve: 'Aprobar' },
      payments: {
        view: 'Ver',
        record: 'Registrar',
        review: 'Revisar cola',
        waive: 'Descontar interés, mora y cargos',
      },
      routes: { manage: 'Gestionar' },
      users: { manage: 'Gestionar' },
      reports: { view: 'Ver' },
      migration: { import: 'Importar cartera' },
    },
    deleteConfirm: '¿Eliminar el rol «{name}»? No se puede deshacer.',
    emptyList: 'Aún no hay roles.',
    created_success: 'Rol creado.',
    updated_success: 'Rol actualizado.',
    deleted_success: 'Rol eliminado.',
    actionFailed: 'No se pudo completar la operación.',
  },
  members: {
    zone: 'Ruta',
    noZone: 'Sin ruta',
    assignZone: 'Asignar ruta',
    zoneHint: 'La ruta que visita este cobrador. Una ruta lleva un cobrador a la vez.',
    zone_assigned_success: 'Ruta actualizada.',
    title: 'Equipo',
    newEmployee: 'Nuevo empleado',
    name: 'Nombre',
    firstName: 'Nombre',
    lastName: 'Apellidos',
    address: 'Dirección (opcional)',
    contact: 'Contacto',
    noContact: 'Sin datos de contacto',
    password: 'Contraseña',
    phone: 'Teléfono (opcional)',
    employee_created_success: 'Empleado creado.',
    email: 'Correo',
    role: 'Rol',
    status: 'Estado',
    active: 'Activo',
    inactive: 'Inactivo',
    joined: 'Alta',
    deactivate: 'Desactivar',
    reactivate: 'Reactivar',
    changeRole: 'Cambiar rol',
    role_assigned_success: 'Rol actualizado.',
    emptyList: 'Todavía no hay miembros.',
    deactivated_success: 'Miembro desactivado.',
    reactivated_success: 'Miembro reactivado.',
    actionFailed: 'No se pudo completar la operación.',
    roles: {
      Admin: 'Administrador',
      Cobrador: 'Cobrador',
    },
  },
  routes: {
    title: 'Rutas',
    create: 'Crear ruta',
    edit: 'Editar ruta',
    viewDetail: 'Ver clientes de la ruta',
    name: 'Nombre',
    collector: 'Cobrador',
    unassigned: 'Sin asignar',
    status: 'Estado',
    active: 'Activa',
    inactive: 'Inactiva',
    activeLabel: 'Ruta activa',
    customers: 'Clientes',
    created: 'Creada',
    emptyList: 'Todavía no hay rutas.',
    created_success: 'Ruta creada.',
    updated_success: 'Ruta actualizada.',
    saved_success: 'Lista de visitas guardada.',
    actionFailed: 'No se pudo completar la operación.',
    visitOrderTitle: 'Orden de visita',
    visitOrderHint:
      'El orden de la lista es el orden en que el cobrador visita a cada cliente. Guarde para aplicar los cambios.',
    emptyStops: 'Esta ruta todavía no tiene clientes.',
    addCustomer: 'Agregar cliente',
    addCustomerHint: 'Busque a alguien que ya esté en otra ruta para traerlo a ésta.',
    searchPlaceholder: 'Busque por nombre, código o teléfono',
    unzonedTitle: 'Clientes sin ruta',
    unzonedHint:
      'No están en ninguna ruta activa, así que ningún cobrador los ve. Agréguelos a esta ruta y guarde.',
    unzonedTruncated: 'Se muestran {shown} de {total}. Guarde y aparecerán los que faltan.',
    addAllUnzoned: 'Agregar los {count} de la lista',
    unzonedWarning:
      'Hay 1 cliente sin ruta: ningún cobrador lo ve. Abra una ruta para colocarlo. | Hay {count} clientes sin ruta: ningún cobrador los ve. Abra una ruta para colocarlos.',
    add: 'Agregar a la ruta',
    remove: 'Quitar de la ruta',
    moveUp: 'Subir',
    moveDown: 'Bajar',
  },
}
